<template>
  <div :class="objClass">
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from '@/utils'
import LadComponentNameMixin from '@/utils/mixin/custom-component-name.js'

export default {
  name: 'LadResizer',
  mixins: [LadComponentNameMixin],
  props: {
    containerClass: { type: String, default: 'lad-resizer' },
    maxXlWidth: { type: Number, default: 1920 },
    maxLgWidth: { type: Number, default: 1200 },
    maxMdWidth: { type: Number, default: 992 },
    maxSmWidth: { type: Number, default: 768 },
    maxXsWidth: { type: Number, default: 768 },
  },
  data() {
    return {
      wrapper: {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }, // new DOMRect()
      objClass: {},
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    sizes() {
      return {
        xl: this.maxXlWidth,
        lg: this.maxLgWidth,
        md: this.maxMdWidth,
        sm: this.maxSmWidth,
        xs: this.maxXsWidth,
      }
    },
  },
  watch: {
    'wrapper.width': {
      immediate: true,
      handler(newValue, oldValue) {
        const isFirstLoad = typeof oldValue === 'undefined'
        const obj = {}
        obj[this.containerClass] = true

        for (const [key, value] of Object.entries(this.sizes)) {
          const isMobileSize = this.isMobile && value <= 992
          const isDesktopSize = !this.isMobile && value > 992

          obj[`${this.containerClass}--${key}`] =
            (isFirstLoad && (isMobileSize || isDesktopSize)) ||
            (newValue > 0 && newValue < value)
        }

        this.objClass = obj
      },
    },
  },
  beforeMount() {
    this.__handleResize = debounce(this.handleResize, 100)

    window.addEventListener('resize', this.__handleResize)
  },
  mounted() {
    this.LadNextTick(
      this.__handleResize,
      `LadResizer - ${this.getComponentName()}`
    )
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.__handleResize)
  },
  methods: {
    handleResize() {
      const container = this.$el

      if (container) {
        try {
          this.wrapper = container.getBoundingClientRect()
        } catch (error) {
          this.wrapper.width = container.clientWidth
        }
      }
    },
  },
}
</script>
